import { useState } from "react";

function App() {
  const json = localStorage.getItem("sections")
    ? JSON.parse(localStorage.getItem("sections"))
    : [];

  let [sections, setSections] = useState(json);

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    try {
      const fileText = await file.text();

      const parsedData = JSON.parse(fileText);

      if (Array.isArray(parsedData)) {
        setSections(parsedData);
        localStorage.setItem("sections", JSON.stringify(parsedData));
      } else {
        console.error("JSON file should contain an array");
      }
    } catch (error) {
      console.error("Error reading or parsing JSON file:", error);
    }
  };

  const handleNewUrl = async () => {
    const url = prompt("Load a new URL with channels");

    if (!url) return;

    try {
      const parsedData = await (await fetch(url)).json();
      setSections(parsedData);
      localStorage.setItem("sections", JSON.stringify(parsedData));
    } catch (error) {
      console.error("Error reading or parsing JSON file:", error);
    }
  };

  const handleText = async () => {
    const text = prompt("Load a new JSON with channels");

    if (!text) return;

    try {
      setSections(JSON.parse(text));
      localStorage.setItem("sections", text);
    } catch (error) {
      console.error("Error reading or parsing JSON file:", error);
    }
  };

  const handleSelectFile = () => {
    const fileInput = document.getElementById("file");
    fileInput.click();
  };

  return (
    <section className="bg-gray-800 text-white p-10 font-mono min-h-dvh">
      {sections.map((section) => (
        <>
          <h1 className="text-3xl uppercase mb-10 font-medium">
            {section.name}
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-10">
            {section.channels.map((channel) => (
              <a
                href={channel.url}
                className="border px-4 py-4 font-medium truncate rounded-lg uppercase bg-gray-900 hover:bg-gray-700 text-center"
              >
                {channel.name}
              </a>
            ))}
          </div>
        </>
      ))}

      <div className="flex flex-wrap gap-4">
        <button
          onClick={handleSelectFile}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Load File
        </button>
        <button
          onClick={handleNewUrl}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Load URL
        </button>
        <button
          onClick={handleText}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Load Text
        </button>
        <input
          id="file"
          type="file"
          onChange={handleFileChange}
          accept="application/json"
          className="hidden"
        />
      </div>
    </section>
  );
}

export default App;
